import React from 'react'
import { Tag, Code, Lightbulb, FileText, Globe } from 'lucide-react'
import './TipoIcon.css'

export const tipoConfig = {
  marca: {
    label: 'Registro de Marca',
    icon: Tag,
    className: 'inpi-tipo-icon inpi-tipo-marca'
  },
  software: {
    label: 'Registro de Software',
    icon: Code,
    className: 'inpi-tipo-icon inpi-tipo-software'
  },
  marca_internacional: {
    label: 'Marca Internacional',
    icon: Globe,
    className: 'inpi-tipo-icon inpi-tipo-marca'
  },
  patente: {
    label: 'Patente',
    icon: Lightbulb,
    className: 'inpi-tipo-icon inpi-tipo-patente'
  },
  outro: {
    label: 'Outro',
    icon: FileText,
    className: 'inpi-tipo-icon inpi-tipo-outro'
  }
}

function TipoIcon({ tipo, showLabel = false }) {
  const key = tipoConfig[tipo] ? tipo : 'outro'
  const config = tipoConfig[key]
  const Icon = config.icon
  return (
    <div className="inpi-tipo-wrapper">
      <span className={`${config.className}`}>
        <Icon size={14} />
      </span>
      {showLabel && <span className="inpi-tipo-label">{config.label}</span>}
    </div>
  )
}

export default TipoIcon
